<template>
  <div class="p-2.5 h-full overflow-hidden flex flex-col">
    <ul class="flex gap-x-5 items-center border-b p-2.5">
      <text v-if="state.model?.status == 1" class="text-blue-500 text-sm"
        >启用</text
      >
      <text v-else class="text-red-500 text-sm">停用</text>
      <strong>{{ state.model?.name }}</strong>
      <text class="text-gray-400 text-xs">
        {{ state.model?.d_hotel_rating_name }}
      </text>
    </ul>
    <div class="flex flex-col overflow-hidden p-2 bg-white flex-1">
      <div class="flex px-5">
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 0
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 0"
        >
          基本信息
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 1
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 1"
        >
          联系人
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 2
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 2"
        >
          房型管理
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 3
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 3"
        >
          宴会厅管理
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 4
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 4"
        >
          附件
        </li>
      </div>
      <div class="rounded-lg bg-gray-100 flex overflow-hidden">
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 0 && state.model?.id"
        >
          <c_more :model="state.model" @load="onLoad" />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 1 && state.model?.id"
        >
          <c_lianxiren :hotel_id="state.model?.id" />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 2"
        >
          <c_fangxing :hotel_id="state.model?.id" />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 3"
        >
          <c_yanhuiting :hotel_id="state.model?.id" />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 4"
        >
          <c_fujian :hotel_id="state.model?.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { hotel_detail } from "@/http/hotel";

import c_more from "./Detail/More.vue";
import c_lianxiren from "./Detail/LianXiRen/List.vue";
import c_fangxing from "./Detail/FangXing/List.vue";
import c_yanhuiting from "./Detail/YanHuiTing/List.vue";
import c_fujian from "./Detail/FuJian/List.vue";

export default {
  props: {
    data: Object,
  },
  components: {
    c_more,
    c_lianxiren,
    c_fangxing,
    c_yanhuiting,
    c_fujian,
  },
  setup(props) {
    const state = reactive({
      nav_index: 0,
    });
    onMounted(() => {
      onLoad();
      state.model = {};
    });

    const onLoad = () => {
      if (props.data?.id) {
        hotel_detail(props.data?.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    };
    return { state, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
